import { nanoid } from "nanoid";
import React, { createContext, useContext, useEffect, useState } from "react";
import { AlertCircle, CheckCircle } from "react-feather";
import "./toast.scss";

// Constants
export const ToastTypes = {
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};

// Context Setup
const ToastContext = createContext({
  toast: () => {},
});

// Provider Component
const ToastProvider = ({ children }) => {
  const [messageList, setMessageList] = useState([]);

  const removeToast = (key) => {
    setMessageList((prev) => prev.filter((msg) => msg.key !== key));
  };

  const setToast = (text, type = ToastTypes.SUCCESS) => {
    const key = nanoid();
    setMessageList((prev) => [{ key, text, type }, ...prev].slice(0, 4));

    setTimeout(() => removeToast(key), 10000);
  };

  return (
    <ToastContext.Provider value={{ toast: setToast }}>
      {messageList.length > 0 && (
        <div className="sbs-toast-container overflow-hidden px-3 py-2">
          {messageList.map((msg) => (
            <ToastItem key={msg.key} text={msg.text} type={msg.type} />
          ))}
        </div>
      )}
      {children}
    </ToastContext.Provider>
  );
};

// Toast Item Component
const ToastItem = ({ text, type }) => {
  const [animationClass, setAnimationClass] = useState("slide-in");

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setAnimationClass("slide-out");
    }, 9800);
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <div
      className={`${animationClass} bg-dark text-white rounded my-2 px-3 py-2 shadow-sm hstack gap-1`}
    >
      <div style={{ width: "30px" }}>
        {type === ToastTypes.SUCCESS ? (
          <CheckCircle size={23} className="text-success" />
        ) : type === ToastTypes.ERROR ? (
          <AlertCircle size={23} className="text-danger" />
        ) : null}
      </div>
      <div className="ms-3">{text}</div>
    </div>
  );
};

// Hook
export const useToast = () => {
  const { toast } = useContext(ToastContext);
  return typeof toast === "function" ? toast : () => {};
};

export default ToastProvider;
